import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { identity } from '@antv/util';
import { Continuous } from './continuous';
import { createInterpolateValue } from '../utils';
import { d3Ticks } from '../tick-methods/d3-ticks';
var transformPow = function transformPow(exponent) {
  return function (x) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
  };
};
var transformPowInvert = function transformPowInvert(exponent) {
  return function (x) {
    return x < 0 ? -Math.pow(-x, 1 / exponent) : Math.pow(x, 1 / exponent);
  };
};
var transformSqrt = function transformSqrt(x) {
  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
};
/**
 * Pow 比例尺
 *
 * 类似于 linear scale, 不同之处在于在计算输出范围值之前对输入域值应用了指数变换,.
 * 即 y = x ^ k 其中 k（指数）可以是任何实数。
 */
export var Pow = /*#__PURE__*/function (_Continuous) {
  _inherits(Pow, _Continuous);
  _createClass(Pow, [{
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return {
        domain: [0, 1],
        range: [0, 1],
        nice: false,
        clamp: false,
        round: false,
        exponent: 2,
        interpolate: createInterpolateValue,
        tickMethod: d3Ticks,
        tickCount: 5
      };
    } // 显示指定 options 的类型为 PowOptions O 的类型
  }]);
  function Pow(options) {
    _classCallCheck(this, Pow);
    return _possibleConstructorReturn(this, _getPrototypeOf(Pow).call(this, options));
  }
  _createClass(Pow, [{
    key: "chooseTransforms",
    value: function chooseTransforms() {
      var exponent = this.options.exponent;
      if (exponent === 1) return [identity, identity];
      var transform = exponent === 0.5 ? transformSqrt : transformPow(exponent);
      var untransform = transformPowInvert(exponent);
      return [transform, untransform];
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Pow(this.options);
    }
  }]);
  return Pow;
}(Continuous);